import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BrandingConfig } from "../models/brandingConfig.model";

const API_URL = `${environment.API_URL}api/brandings/`;

@Injectable({
    providedIn: "root"
})
export class BrandingConfigService {
    constructor(private http: HttpClient) {}

    getAllBrandingConfigs(){
        return this.http.get(API_URL);
    }
    getCurrentBrandingConfig(){
        return this.http.get<BrandingConfig>(`${API_URL}current`);
    }
    getBrandingConfig(id: number){
        return this.http.get<BrandingConfig>(`${API_URL}${id}`);
    }
    createBrandingConfig(campaignId: string, primaryColor: string, secondaryColor: string){
        return this.http.post<BrandingConfig>(API_URL,{campaignId,primaryColor,secondaryColor});
    }
    editBrandingConfig(brandingConfig : BrandingConfig){
        return this.http.put<BrandingConfig>(`${API_URL}${brandingConfig.id}`,brandingConfig);
    }
    uploadBrandingConfigImages(brandingId: number, headerLogo: File, loginLogo: File, loginBackground: File, registerBackground: File) {
        const url = `${API_URL}imageupload/${brandingId}`;
        const formData: FormData = new FormData();
        if (headerLogo)
            formData.append("headerLogo", headerLogo, headerLogo.name);
        if(loginLogo)
            formData.append("loginLogo", loginLogo, loginLogo.name);
        if(loginBackground)
            formData.append("loginBackground", loginBackground, loginBackground.name);
        if (registerBackground)
            formData.append("registerBackground", registerBackground, registerBackground.name);
        return this.http.post<BrandingConfig>(url, formData);
    }
}
